<template>
  <div v-if="standalone" :class="containerClass">
    <div v-if="dayData" class="grid grid-cols-4 gap-4">
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Device On</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.deviceOnDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Device Worn</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.deviceWornDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Extreme Negative</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.extremeNegativeDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Date</div>
        <div class="font-mono text-sm font-semibold">{{ formattedDate }}</div>
      </div>
    </div>
    <div v-else class="col-span-4 text-center text-gray-500">
      Select a day to view metrics
    </div>
  </div>
  <div v-else>
    <div v-if="dayData" class="grid grid-cols-4 gap-4">
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Device On</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.deviceOnDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Device Worn</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.deviceWornDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Extreme Negative</div>
        <div class="font-mono text-sm font-semibold">{{ dayData.extremeNegativeDuration || 'N/A' }} hrs</div>
      </div>
      <div class="text-center">
        <div class="font-medium text-gray-400 uppercase text-xs mb-1">Date</div>
        <div class="font-mono text-sm font-semibold">{{ formattedDate }}</div>
      </div>
    </div>
    <div v-else class="col-span-4 text-center text-gray-500">
      Select a day to view metrics
    </div>
  </div>
</template>

<script>
export default {
  name: 'DaySummary',
  props: {
    // Day data object containing metrics
    dayData: {
      type: Object,
      default: () => null
    },
    // Whether to render as a standalone component with its own container styling
    standalone: {
      type: Boolean,
      default: true
    },
    // Optional: custom styling for the container
    containerClass: {
      type: String,
      default: 'text-xs text-gray-500 bg-purple-50 p-4 rounded border-2 border-gray-400'
    },
    // Optional: custom styling for metric labels
    labelClass: {
      type: String,
      default: 'font-medium text-gray-400 uppercase text-xs mb-1'
    },
    // Optional: custom styling for metric values
    valueClass: {
      type: String,
      default: 'font-mono text-sm font-semibold'
    },
    // Optional: custom styling for the grid
    gridClass: {
      type: String,
      default: 'grid grid-cols-4 gap-4'
    },
    // Optional: custom styling for individual metric items
    metricClass: {
      type: String,
      default: 'text-center'
    },
    // Optional: custom styling for the no data message
    noDataClass: {
      type: String,
      default: 'col-span-4 text-center text-gray-500'
    },
    // Optional: custom no data message
    noDataMessage: {
      type: String,
      default: 'Select a day to view metrics'
    },
    // Optional: specify which day features to display
    enabledFeatures: {
      type: Array,
      default: () => [
        'deviceOnDuration', 'deviceWornDuration', 'extremeNegativeDuration', 'date'
      ]
    }
  },
  computed: {
    // Format the date for display
    formattedDate() {
      if (!this.dayData?.displayDate) return 'N/A'
      return new Date(this.dayData.displayDate).toLocaleDateString('en-US')
    },
    
    // Check if there is day data
    hasDayData() {
      return this.dayData !== null && this.dayData !== undefined
    }
  }
}
</script>

<style scoped>
/* Component-specific styles can be added here if needed */
</style>
